// import {fetchDevices} from '@/devicehq/api/devices'
import {fetchDeviceId} from '@/devicehq/api/deviceId'
import {DEVICEHQ} from '@/devicehq/api'

const getDevices = context => {
  // fetchDevices
  DEVICEHQ.get('/api/v2/devices?limit=30', {
    data: {},
  })
    .then(response => {
      context.commit('DEVICES_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const getDevice = (context, payload) => {
  DEVICEHQ.get(`/api/v2/devices/${payload.uuid}`, {
    data: {},
  })
  .then(response => {
    context.commit('DEVICE_UPDATED', response)
  })
  .catch(error => {
    // eslint-disable-next-line
    console.error(error)
  })
}

const updateDevice = (context, payload) => {
  console.log('update device with:')
  console.log(payload)
  // console.log(DEVICEHQ)
  DEVICEHQ.put(`/api/v2/devices/${payload.data.id}`, {
    data: payload.data,
  })
  .then(response => {
    context.commit('DEVICE_UPDATED', response)
  })
  .catch(error => {
    // eslint-disable-next-line
    console.error(error)
  })
}

export default {
  getDevices,
  getDevice,
  updateDevice,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/devices/actions.js